import React from 'react';
import './Skills.css';
import Frontend from './Frontend';
import Backend from './Backend';

const Skills = () => {
  return (
    <section className="skills section" id="skills">
        <h2 className="section__title" data-aos="fade-down">Skills</h2>
        <span className="section__subtitle" data-aos="fade-down" data-aos-delay="200">My Technical level</span>

        <div className="skills__container container grid">
            <div data-aos="fade-right" data-aos-delay="300">
                <Backend />
            </div>
            <div data-aos="fade-left" data-aos-delay="300">
                <Frontend />
            </div>
        </div>
    </section>
  )
}

export default Skills